import { ErrorOutline } from "@mui/icons-material";
import { lighten, styled } from "@mui/material";
import VibratingIcon from "../commons/icons/vibratingIcon/VibratingIcon";

export const StyledRequerido = {
    LabelContainer: styled("div")(({ theme, labelContainerStyle }) => ({
        display: "flex",
        margin: "25px",
        padding: "10px",
        backgroundColor: lighten(theme.palette.tertiary.main, 0.8),
        width: "fit-content",
        borderRadius: "10px",
        color: theme.palette.tertiary.main,
        ...(labelContainerStyle || {})
    })),
    Icon: styled(ErrorOutline)(({ theme }) => ({
        marginRight: "15px",
        alignSelf: "center",
    })),
}

export const StyledFeature = {
    LabelContainer: styled("div")(({ theme }) => ({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "15px",
        padding: "5px",
        backgroundColor: lighten(theme.palette.tertiary.main, 0.8),
        width: "fit-content",
        borderRadius: "10px",
        border: `2px solid ${lighten(theme.palette.tertiary.main, 0.5)}`,
        color: theme.palette.tertiary.main,
    })),
    Icon: styled(VibratingIcon)(({ theme }) => ({
        marginLeft: "10px",
    })),
}

export const StyledData = {
    DataContainer: styled("div")(({ theme }) => ({
        width: "90%",
        display: "flex",
        justifyContent: "space-between",
        padding: "10px",
        border: `3px solid ${theme.palette.primary.main}`,
        boxShadow: "10px 10px 20px -15px",
        borderRadius: "10px",
        margin: "15px",
    })),
    LastTypo: styled("div")(({ theme }) => ({
        display: "flex",
    })),
}

export const StyledInputLabel = {
    Chip: styled("div")(({ theme }) => ({
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 10,
        height: "20px",
        marginTop: "10px",
        backgroundColor: theme.palette.primary.main,
        color: "white",
        padding: theme.spacing(0, 2),
        "&:hover": {
            backgroundColor: theme.palette.primary.light,
        },
    })),
}